import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from 'components/Tooltip/Tooltip';
import { Level } from 'components/Modals/Modal/type';
import { QuestionsManagerModal } from '../QuestionsManagerModal/QuestionsManagerModal';
import { TriggerLabel, TriggerWrapper } from './QuestionsManagerButton.styled';

interface IQuestionsManagerButtonProps {
  configurationId: number | null | undefined;
  modelName: string;
  currency: string;
  hasActiveQuestions?: boolean;
  level?: Level;
}

// Entry point shown in each model's configuration row. Questions are nested
// resources under a saved configuration, so the manager can only be opened once
// the configuration has been created (the supplier must press Apply first).
export const QuestionsManagerButton = ({
  configurationId,
  modelName,
  currency,
  hasActiveQuestions = false,
  level = 'FIRST',
}: IQuestionsManagerButtonProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const isDisabled = !configurationId;

  return (
    <TriggerWrapper isDisabled={isDisabled}>
      <Tooltip
        content={
          isDisabled
            ? t('Apply the configuration first to manage extra price questions')
            : undefined
        }
      >
        <TriggerLabel
          isActive={hasActiveQuestions}
          isDisabled={isDisabled}
          onClick={() => !isDisabled && setIsOpen(true)}
        >
          {t('Extra questions')}
        </TriggerLabel>
      </Tooltip>
      {!isDisabled && (
        <QuestionsManagerModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          configurationId={configurationId as number}
          modelName={modelName}
          currency={currency}
          level={level}
        />
      )}
    </TriggerWrapper>
  );
};
